import { type ReactNode, useContext } from 'react';
import { BlockSurfaceContext } from './block-surface-context';
import { LayoutProvider } from './layout-provider';

/**
 * Cards bring their own surface, so they render in the page's layout whatever the block's
 * background: plan cards, the billing toggle, a video's poster card.
 */
export const PageSurface = ({ children }: { children: ReactNode }) => {
  const value = useContext(BlockSurfaceContext);
  if (!value) return children;

  return (
    <BlockSurfaceContext.Provider value={null}>
      <LayoutProvider layout={value.page}>{children}</LayoutProvider>
    </BlockSurfaceContext.Provider>
  );
};
